import { useEffect, useState } from "react";
import { Card, CardBody } from "./../../components/card/card.jsx";
function QtyMechanicByArea({ data }) {
  const [qtyByArea, setQtyByArea] = useState([]);
  useEffect(() => {
    setQtyByArea(data);
  }, [data]);
  return (
    <>
      <Card>
        <CardBody className="d-flex align-items-center text-inverse m-5px bg-inverse bg-opacity-10">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>Area</th>
                  <th>Current</th>
                  <th>Last Year</th>
                  <th>Dev</th>
                </tr>
              </thead>
              <tbody>
                {qtyByArea.length > 0 ? (
                  qtyByArea.map((val, index) => (
                    <tr key={index}>
                      <td>{val.jobArea}</td>
                      <td>{val.qty.current}</td>
                      <td>{val.qty.lastYear}</td>
                      <CountDev data={val.qty} />
                    </tr>
                  ))
                ) : (
                  <></>
                )}
              </tbody>
            </table>
          </div>
        </CardBody>
      </Card>
    </>
  );
}
export default QtyMechanicByArea;

function CountDev({ data }) {
  const [theme, setTheme] = useState("text-inverse");
  const [val, setVal] = useState(0);
  function themeCalc(d) {
    if (d < 0) {
      setTheme("text-danger");
      return;
    }
    if (d > 0) {
      setTheme("text-theme");
      return;
    }
    setTheme("text-inverse");
  }
  useEffect(() => {
    const dev = data.current - data.lastYear;
    setVal(dev);
    themeCalc(dev);
  }, [data]);

  return (
    <>
      <td className={theme}>{val}</td>
    </>
  );
}
